import { AssignmentIndOutlined } from "@mui/icons-material";
import { isEmpty } from "lodash";
import { useMemo } from "react";
import { useSelector } from "react-redux";
import DismissibleAlert from "./DismissibleAlert";

const ProfileRequirementsAlert = ({ children }) => {
  const profile = useSelector((state) => state?.profile);

  const isComplete = useMemo(() => {
    const associatedEntities = profile?.associatedEntities || [];
    const validatedExperience = profile?.validatedExperience || [];

    if (isEmpty(associatedEntities)) {
      return false;
    }

    if (isEmpty(validatedExperience)) {
      return false;
    }

    return true;
  }, [profile]);
  return (
    <DismissibleAlert
      show={!isComplete}
      severity="warning" // Changed from "error" to "warning"
      // icon={<AssignmentLate className="thin" fontSize="inherit" />}
      icon={<AssignmentIndOutlined className="thin" fontSize="inherit" />}
      fontSize="12px"
      // alertId="profile-requirements"
      //   hideDuration={24}
    >
      Complete Your Profile: Add your entities and experience to streamline your
      loan process. You'll need this information before closing.
    </DismissibleAlert>
  );
};
export default ProfileRequirementsAlert;
